<header class="topbar">
  <button
    class="mobile-menu-button"
    type="button"
    aria-label="Abrir menu principal"
    [attr.aria-expanded]="mobileMenuVisible"
    (click)="mobileMenuOpened.emit()"
  >
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 6h16" />
      <path d="M4 12h16" />
      <path d="M4 18h16" />
    </svg>
  </button>

  <a class="brand" href="#" aria-label="RAM">
    <img class="brand-mark" src="/brand/ram-leaf.png" alt="" aria-hidden="true" />
    <span class="brand-name">RAM</span>
    <span class="brand-subtitle">Real Acequia de Moncada</span>
  </a>

  <label class="top-search">
    <span class="visually-hidden">Buscar por referencia catastral</span>
    <input
      type="search"
      name="cadastralReferenceSearch"
      [ngModel]="cadastralReferenceSearch"
      (ngModelChange)="updateCadastralReferenceSearch($event)"
      placeholder="Buscar por referencia catastral..."
      autocomplete="off"
      inputmode="search"
    />
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="6.2" />
      <path d="m16 16 4.2 4.2" />
    </svg>
  </label>

  <div class="top-actions">
    @if (isPublicAccess) {
      <button class="help-button" type="button" aria-label="Ayuda">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M9.8 9a2.4 2.4 0 0 1 4.4 1.3c0 1.7-2.2 2-2.2 3.7" />
          <path d="M12 17.5h.01" />
        </svg>
        <span>Ayuda</span>
      </button>
    }

    @if (!isPublicAccess) {
      <button class="icon-button notification-button" type="button" aria-label="Notificaciones">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
          <path d="M10 21h4" />
        </svg>
        <span>3</span>
      </button>
    }

    <button class="user-menu" type="button" aria-label="Menu de usuario" (click)="profileSelectionOpened.emit($event)">
      <span class="avatar">
        <img [src]="profileThumbnailPath" [alt]="currentAccessTitle" />
      </span>
      <span class="user-copy">
        <strong>{{ currentAccessTitle }}</strong>
        <small>{{ currentAccessSubtitle }}</small>
      </span>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m6 9 6 6 6-6" />
      </svg>
    </button>
  </div>
</header>
